<template>
  <Index ref="index"/>
</template>

<script>
import Index from './components/Index.vue'
const api = window.api;
const languages = {
  en: 'en',
  sp: 'es',
  de: 'de',
  it: 'it',
}

export default {
  name: 'App',
  data () {
    return {
      lang: 'en',
      langCode: 'en',
      translations: {}
    }
  },
  components: {
    Index
  },
  async mounted() {
    // Get URL search params
    const urlParams = new URLSearchParams(window.location.search);
    let lang = urlParams.get('Lang');
    if (!lang) lang = 'en';
    this.lang = lang.toLowerCase();
    this.langCode = languages[this.lang];
    this.$store.commit('setLang', lang);
    this.$store.commit('setCustom')
    this.translations = require(`@/assets/languages/${this.lang}.json`);
    await this.getCurrentUser();
  },
  methods: {
    tr (text) {
      if (!text) return text;
      try {
        if (this.translations[text]) return this.translations[text];
      } catch (err) {
          //console.log(err)  
      }
      return text
    },
    async getCurrentUser () {
      let res = await api.get('/api/current_user/');
      if (res) {
        this.$store.commit('setUser', res);
      }
      return res;
    }
  }
}
</script>